export default "__VITE_ASSET__6eWjkN1R__"